// Every game this person finished, signed in or not. The list lives on the
// device; a signed-in player also sees the runs the leaderboard holds for
// their name, so games played on another phone are not missing.
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { readPlays } from '../services/playHistory';
import { getLeaderboard } from '../services/leaderboardService';
import { useUsername } from '../hooks/useUsername';
import PlayHistory from '../components/PlayHistory/PlayHistory';
import GuestNudge from '../components/GuestNudge/GuestNudge';
import './MyGames.css';

const BOARDS = ['character', 'image', 'devilfruit', 'bounty'];

// The same run saved here and on the board matches on game, score and time.
const sameRun = (a, b) => a.gameType === b.gameType && a.score === b.score && a.totalTime === b.totalTime;

export default function MyGames() {
  const { username, isAuthenticated } = useUsername();
  const [plays, setPlays] = useState(readPlays);

  useEffect(() => {
    if (!isAuthenticated || !username) return undefined;
    let alive = true;
    Promise.all(BOARDS.map((b) => getLeaderboard(b, 500).catch(() => [])))
      .then((boards) => {
        if (!alive) return;
        const local = readPlays();
        const mine = boards.flat()
          .filter((e) => e.username === username)
          .map((e) => ({ gameType: e.gameType, score: e.score, totalTime: e.totalTime, at: new Date(e.date).getTime() || 0 }))
          .filter((e) => !local.some((l) => sameRun(l, e)));
        setPlays([...local, ...mine].sort((a, b) => b.at - a.at));
      });
    return () => { alive = false; };
  }, [isAuthenticated, username]);

  return (
    <div className="mg-container">
      <Helmet>
        <title>Your Games — One Piece Trivia</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="mg-card">
        <h1 className="mg-title">Your games</h1>
        <p className="mg-sub">
          {isAuthenticated
            ? 'Games on this device, plus your leaderboard runs from any device.'
            : 'Saved on this device. No account needed.'}
        </p>
        <GuestNudge />
        <PlayHistory plays={plays} />
      </div>
    </div>
  );
}
